const STORAGE_KEY = 'likiee_comparisons';

const isBrowser = () => typeof window !== 'undefined' && typeof window.localStorage !== 'undefined';

const safeParse = value => {
  try {
    return value ? JSON.parse(value) : [];
  } catch (error) {
    return [];
  }
};

export const loadComparisonHistory = () => {
  if (!isBrowser()) {
    return [];
  }
  const raw = window.localStorage.getItem(STORAGE_KEY);
  const comparisons = safeParse(raw);
  return Array.isArray(comparisons) ? comparisons : [];
};

export const saveComparisonHistory = comparisons => {
  if (!isBrowser()) {
    return;
  }
  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(comparisons));
};

export const addComparisonToHistory = comparison => {
  const history = loadComparisonHistory();
  const updated = [comparison, ...history];
  saveComparisonHistory(updated);
  return updated;
};

export const toggleComparisonBookmark = comparisonId => {
  const history = loadComparisonHistory();
  const updated = history.map(item =>
    item.id === comparisonId ? { ...item, isBookmarked: !item.isBookmarked } : item,
  );
  saveComparisonHistory(updated);
  return updated;
};

export const updateComparisonInHistory = comparison => {
  const history = loadComparisonHistory();
  const updated = history.map(item => (item.id === comparison.id ? comparison : item));
  saveComparisonHistory(updated);
  return updated;
};
